"use client"
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog"

interface ConfirmViewChangeDialogProps {
  isOpen: boolean
  onClose: () => void
  onConfirm: () => void
  currentMode: "us" | "world"
  hasUnsavedChanges?: boolean
}

export function ConfirmViewChangeDialog({
  isOpen,
  onClose,
  onConfirm,
  currentMode,
  hasUnsavedChanges = true,
}: ConfirmViewChangeDialogProps) {
  const newMode = currentMode === "us" ? "World" : "US"

  // If there are no unsaved changes, just confirm immediately
  if (!hasUnsavedChanges && isOpen) {
    setTimeout(() => onConfirm(), 0)
    return null
  }

  return (
    <AlertDialog open={isOpen} onOpenChange={onClose}>
      <AlertDialogContent className="bg-white shadow-lg border border-gray-200">
        <AlertDialogHeader>
          <AlertDialogTitle>Switch to {newMode} View?</AlertDialogTitle>
          <AlertDialogDescription>
            You have unsaved changes in your current view. Switching to {newMode} view will reset your data to the
            default sample data for that view. Your current changes will be lost, although they are saved in your
            browser's local storage and can be exported to a JSON file if needed.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel>Cancel</AlertDialogCancel>
          <AlertDialogAction onClick={onConfirm}>Switch View</AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  )
}
